module.exports = __webpack_public_path__ + "fonts/f089d3e46278444af24602c4c17e925a.svg";